<template>
    <el-container class="h-full">
        <div class="h-screen bg-main my-top clearfix relative w-full overflow-hidden">

            <!-- Wave-->
            <div class="orc-wave"></div>

            <div class="w-full h-full p-0 absolute flex justify-center">
                <div class="self-center recover-dialog">
                    <div class="text-center w-full mb-4"><h1 class="text-white text-3xl font-thin">Wachtwoord vergeten?</h1></div>
                    <el-card shadow="always" class="orc-wave-blue mb-5">
                        <div class="mx-4 mt-1 mb-10">
                            <div class="mb-6">
                                <h1 class="text-xl"><i class="el-icon-lock mr-2"></i>Herstel wachtwoord</h1>
                            </div>

                            <!-- alert -->
                            <el-alert v-if="processed" title="Aanvraag geregisteerd!" description="Uw aanvraag is geregisteerd, u ontvangt spoedig een mail met verdere instructies, vergeet niet de spam folder te bekijken!" type="success" effect="dark" :closable="false" class="mb-4"></el-alert>
                            <el-alert v-if="error" title="Ongeldig e-mail adres!" type="error" effect="dark" :closable="false" show-icon class="mb-4"></el-alert>

                            <!-- form -->
                            <el-form :model="form" ref="form" :rules="rules">
                                <el-form-item prop="email">
                                    <el-input placeholder="Email adres" v-model="form.email" prefix-icon="el-icon-message"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>

                        <div class="flex justify-center m-4">
                            <el-button type="primary" :loading="loading" @click="submitForm('form')" :disabled="processed">Bevestigen<i class="ml-2 el-icon-right"></i></el-button>
                        </div>
                    </el-card>
                    <div class="flex float-right">
                        <a class="social-badge mr-2" href="https://www.instagram.com/orcabilzen/">
                            <img src="../assets/instagram-brands.svg" width="20" height="20" class="text-white"/>
                        </a>

                        <a class="social-badge" href="https://www.facebook.com/OrcaBilzen/">
                            <img src="../assets/facebook-f-brands.svg" width="15" height="15"/>
                        </a>
                    </div>
                </div>
            </div>

            <div class="w-full absolute">
                <header class="orc-vert-limit-header">
                    <div class="flex justify-between mt-4">
                        <!-- Logo -->
                        <router-link :to="{ path: 'home'}">
                            <div class="logo orc-strong">
                                ORCA
                            </div>
                        </router-link>
                    </div>
                </header>
            </div>
        </div>
    </el-container>
</template>

<script>
    export default {
        name: "Recover",
        data() {
            return {
                form: {
                    email: "",
                },
                dialogVisible: true,
                loading: false,
                error: false,
                processed: false,

                // Rules
                rules: {
                    email: [
                        {type: 'email', required: true, message: 'Vul een geldig email adres in.', trigger: 'blur'}
                    ],
                }
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    this.error = false
                    if (valid) {
                        this.loading = true
                        this.resetPassword()
                    }
                });
            },
            resetPassword() {
                this.$http.post('users/reset/', {
                    'email': this.form.email,
                })
                    .then((response) => {
                        this.processed = true
                        this.loading = false
                    })
                    .catch((error) => {
                        this.error = true
                        this.loading = false
                    })
            }
        }
    }
</script>

<style scoped>
    .recover-dialog {
        width: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Recover.vue